module.exports = __webpack_public_path__ + "img/Add.e1c003d5.svg";